export default __webpack_public_path__ + "static/media/powered-by-poly.4d2d6bf8.svg";